<div
  class="px-4 py-3 border-t border-[#EBEDF3] rounded-b-xl min-w-[480px] w-full"
>
  <div class="flex items-center justify-between gap-3">
    <div class="flex gap-3 items-center" *ngIf="pageSizeShow">
      <p class="text-xs text-[#15191E] font-medium">Rows per page</p>
      <ng-select
        [(ngModel)]="pageSize"
        (change)="switchPage()"
        placeholder="page size"
        [searchable]="false"
        [clearable]="false"
        class="border border-[#E3E6EE] rounded shadow-none text-xs leading-6 font-medium text-[#15191E] focus:shadow-none lg:w-36 w-16 sm-dropdown"
      >
        <ng-option *ngFor="let opt of pageSizeOptions" [value]="opt">{{
          opt
        }}</ng-option>
      </ng-select>
    </div>

    <p *ngIf="totalRecordsShow" class="text-xs text-[#15191E] font-medium">
      Showing <span>{{ pageLength() }}</span> to
      <span>{{ pageLengthTo() }}</span> of
      <span>{{ pageResult?.totalCount ?? 0 }}</span> {{ title }}
    </p>

    <nav class="flex gap-1.5 items-center">
      <p
        *ngIf="totalPaginationCountShow"
        class="text-xs text-[#15191E] font-medium lg:block hidden"
      >
        <span>{{ startingPage || 0 }}</span> -
        <span>{{ endingPage || 0 }}</span> of
        <span>{{ getTotalPages() || 0 }}</span>
      </p>

      <ul class="flex items-center space-x-1 text-[13px] text-[#B9BBC6]">
        <li>
          <a
            href="javascript:void(0)"
            class="flex items-center justify-center size-7 text-[13px] leading-6 text-[#15191E] rounded-md hover:bg-[#F8F8FA]"
            (click)="previousPage()"
            [ngClass]="{
              'cursor-not-allowed': !pageResult?.pageInfo?.hasPreviousPage,
            }"
          >
            <!-- Gray icon when disabled -->
            <img
              *ngIf="!pageResult?.pageInfo?.hasPreviousPage"
              src="../../../assets/images/icons/arrows/pagination-left-gray.svg"
              alt="Left Arrow Disabled"
            />

            <!-- Black icon when enabled -->
            <img
              *ngIf="pageResult?.pageInfo?.hasPreviousPage"
              src="../../../assets/images/icons/arrows/pagination-left-black.svg"
              alt="Left Arrow"
            />
          </a>
        </li>
        <li *ngFor="let item of getPages() | slice: 0 : 3">
          <a
            (click)="onPageClick(item)"
            href="javascript:void(0)"
            class="flex items-center justify-center size-7 leading-6 rounded-lg"
            [ngClass]="
              item === activeIndex
                ? 'text-[#15191E] bg-[#F8F8FA] hover:bg-[#F8F8FA]'
                : 'hover:bg-[#F8F8FA] hover:text-[#15191E]'
            "
          >
            {{ item }}
          </a>
        </li>

        <li>
          <a
            href="javascript:void(0)"
            class="flex items-center justify-center size-7 text-[13px] leading-6 text-[#15191E] rounded-md hover:bg-[#F8F8FA]"
            (click)="nextPage()"
            [ngClass]="{
              'cursor-not-allowed': !pageResult?.pageInfo?.hasNextPage,
            }"
          >
            <!-- Gray icon when disabled -->
            <img
              *ngIf="!pageResult?.pageInfo?.hasNextPage"
              src="../../../assets/images/icons/arrows/pagination-right-gray.svg"
              alt="Right Arrow Disabled"
            />

            <!-- Black icon when enabled -->
            <img
              *ngIf="pageResult?.pageInfo?.hasNextPage"
              src="../../../assets/images/icons/arrows/pagination-right-black.svg"
              alt="Right Arrow"
            />
          </a>
        </li>
      </ul>
    </nav>
  </div>
</div>
